export default "Bliv jægerstenalderbørn ligesom Ask & Liv og lav jeres egne buer og pile af naturmaterialer.";